/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import SashiDo from 'lib/SashiDo';
import { ActionTypes } from 'lib/stores/JobsStore';
import Button from 'components/Button/Button.react';
import * as DateUtils from 'lib/DateUtils';
import DashboardView from 'dashboard/DashboardView.react';
import CategoryList from 'components/CategoryList/CategoryList.react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import history from 'dashboard/history';
import Icon from 'components/Icon/Icon.react';
import Modal from 'components/Modal/Modal.react';
import modalStyles from 'components/Modal/Modal.scss';
import React from 'react';
import ReleaseInfo from 'components/ReleaseInfo/ReleaseInfo';
import RunNowButton from 'dashboard/Data/Jobs/RunNowButton.react';
import SidebarAction from 'components/Sidebar/SidebarAction';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';
import stylesButton from 'components/Button/Button.scss';
import subscribeTo from 'lib/subscribeTo';

import SashiDoTableView from 'dashboard/SashiDoTableView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';

let subsections = {
  scheduled: 'Scheduled Jobs',
  status: 'Job Status'
};

let statusColors = {
  running: 'blue',
  succeeded: 'green',
  failed: 'red',
};

function scheduleString(data) {
  let schedule = '';
  let runAt = new Date(data.startAfter);

  if (data.repeatMinutes) {
    if (data.repeatMinutes === 1440) {
      schedule += 'Every day, ';
    } else if (data.repeatMinutes > 60) {
      schedule += 'Each day, every ' + ((data.repeatMinutes / 60) | 0) + ' hours, ';
    } else {
      schedule += 'Each day, every ' + data.repeatMinutes + ' minutes, ';
    }
    // schedule += 'after ' + (runAt.getUTCHours() < 10 ? '0' : '') + runAt.getUTCHours() + ':' + (runAt.getUTCMinutes() < 10 ? '0' : '') + runAt.getUTCMinutes() + ', ';
    schedule += 'starting ';
  } else {
    schedule = 'On ';
  }
  // schedule += runAt.getUTCMonth() + '/' + runAt.getUTCDate() + '/' + String(runAt.getUTCFullYear()).substr(2);
  // schedule += ' at ' + (runAt.getUTCHours() < 10 ? '0' : '') + runAt.getUTCHours() + ':' + (runAt.getUTCMinutes() < 10 ? '0' : '') + runAt.getUTCMinutes();
  schedule += DateUtils.dateStringUTC(runAt);
  return <div className='trim'>{schedule}</div>;
}

// TODO: create scrollable view component that handles lazy fetch container on scroll
@subscribeTo('Jobs', 'jobs')
export default class Jobs extends SashiDoTableView {
  constructor() {
    super();
    this.section = 'Core';
    this.subsection = 'Jobs';

    this.state = {
      loading: true,
      inactive: true,
      toDelete: null,
      toDeleteName: null,
      jobStatus: undefined,
      loading: true,
    };
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.availableJobs) {
      if (nextProps.availableJobs.length > 0) {
        this.action = new SidebarAction('Schedule a job', this.navigateToNew.bind(this));
        return;
      }
    }
    this.action = null;
    this.loadData();
  }

  loadData() {
    this.setState({
      loading: true
    }, () => {
      this.props.jobs.dispatch(ActionTypes.FETCH).finally(() => {
        this.setState({ loading: false });
      });
      this.context.currentApp.getJobStatus().then((status) => {
        this.setState({ jobStatus: status });
      });
    }
    );
  }

  navigateToNew() {
    history.push(this.context.generatePath('jobs/new'));
  }

  navigateToJob(jobId) {
    history.push(this.context.generatePath(`jobs/edit/${jobId}`))
  }

  renderSidebar() {
    let current = this.props.params.section || '';
    return (
      <CategoryList current={current} linkPrefix={'jobs/'} categories={[
        { name: 'Scheduled Jobs', id: 'scheduled' },
        { name: 'Job Status', id: 'status' }
      ]} />
    );
  }

  renderRow(data) {
    if (this.props.params.section === 'scheduled') {
      return (
        <tr key={data.objectId}>
          {
            this.state.inactive
              ?
              <td>
                {data.inactive
                  ? <a
                    className={[stylesButton.tableButton, stylesButton.green].join(' ')}
                    href='javascript:;'
                    onClick={() => this.activateJob(data.objectId)}
                    onClick={() => this.setState({ toActivate: data.objectId, toActivateName: data.description })}>
                    Activate
                  </a>
                  : 'Scheduled'
                }
              </td>
              : null
          }
          <td>{data.description}</td>
          <td>{data.jobName}</td>
          <td>{scheduleString(data)}</td>
          <td>
            <div className='actions'>
              {data.inactive ? null : <RunNowButton job={data} width={'100px'} />}

              {data.inactive ? null :
                <a
                  className={[stylesButton.tableButton, stylesButton.blue].join(' ')}
                  href='javascript:;'
                  onClick={() => this.navigateToJob(data.objectId)}>
                  Edit
                </a>
              }

              <a
                className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                href='javascript:;'
                onClick={() => this.setState({ toDelete: data.objectId, toDeleteName: data.description })}>
                Delete
              </a>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.params.section === 'status') {
      return (
        <tr key={data.objectId}>
          <td>{data.jobName}</td>
          <td>{DateUtils.dateStringUTC(new Date(data.createdAt))}</td>
          <td><div>{data.message}</div></td>
          <td>
            <StatusIndicator status={data.status} color={statusColors[data.status]} />
          </td>
        </tr>
      );
    }
  }

  renderHeaders() {
    let headers = null;
    this.props.params.section === 'scheduled'
      ?
      headers = [
        <colgroup key={this.props.params.section + '_colgroup'}>
          {this.state.inactive ? <col width="12%" /> : null}
          <col width="12%" />
          <col width="18%" />
          <col />
          <col width="190px" />
        </colgroup>,
        <thead key={this.props.params.section + '_thead'}>
          <tr>
            {this.state.inactive ? <th>Status</th> : null}
            <th>Name</th>
            <th>Function</th>
            <th>Schedule (UTC)</th>
            <th>Actions</th>
          </tr>
        </thead>
      ]
      :
      headers = [
        <colgroup>
          <col width="25%" />
          <col width="25%" />
          <col />
          <col width="190px" />
        </colgroup>,
        <thead>
          <tr>
            <th>Function</th>
            <th>Started At (UTC)</th>
            <th>Message</th>
            <th>Status</th>
          </tr>
        </thead>
      ]

    return headers
  }

  renderEmpty() {
    if (this.props.params.section === 'scheduled') {
      return (
        <EmptyState
          title='Cloud Jobs'
          description='Schedule your Cloud Code functions to run at specific times.'
          cta={this.props.availableJobs && this.props.availableJobs.length ? 'Schedule a job' : null}
          action={this.navigateToNew.bind(this)} />
      );
    } else {
      return (
        <EmptyState
          title='Job Status'
          description='There are no active jobs to show at this time.'
          cta={this.props.availableJobs && this.props.availableJobs.length ? 'Schedule a job' : null}
          action={this.navigateToNew.bind(this)} />
      );
    }
  }

  renderExtras() {
    if (this.state.toDelete) {
      return (
        <Modal
          type={Modal.Types.DANGER}
          title='Delete job schedule?'
          subtitle='Be careful, this action cannot be undone!'
          confirmText='Delete'
          cancelText={'Cancel'}
          onCancel={() => this.setState({ toDelete: null })}
          onConfirm={() => {
            this.setState({ toDelete: null });
            this.props.jobs.dispatch(ActionTypes.DELETE, { jobId: this.state.toDelete });
            SashiDo.activityTrack({
              type: 'delete_job',
              data: {
                message: `Successfully deleted Job (${this.state.toDeleteName}) for application ${this.context.currentApp.name}`,
              },
            });
          }}
        >
          {this.props.jobsInUse && this.props.jobsInUse.length > 1
            ? <div className={modalStyles.only}>If you decide to delete a Cloud Job keep in mind that the creation of every new job will cost you $10/mo. Please consider editing THIS ONE.</div>
            : null
          }

          <div className={modalStyles.only}>Job with name <strong>{this.state.toDeleteName}</strong> will be deleted.</div>
        </Modal>
      );
    }

    if (this.state.toActivate) {
      return (
        <Modal
          title='Activate job'
          confirmText='Activate'
          cancelText={'Cancel'}
          onCancel={() => this.setState({ toActivate: null })}
          onConfirm={() => {
            this.setState({ toActivate: null })
            this.props.jobs.dispatch(ActionTypes.ACTIVATE, { jobId: this.state.toActivate });
          }}
        >
          {this.props.jobsInUse && this.props.jobsInUse.length > 1
            ? <div className={modalStyles.only}>You have one active Cloud Job. Every new job will cost you $10/mo.</div>
            : null
          }

          <div className={modalStyles.only}>Activate Cloud Job with name <strong>{this.state.toActivateName}</strong></div>
        </Modal>
      );
    }
  }

  tableData() {
    let data = undefined;
    if (this.props.params.section === 'scheduled') {
      if (this.props.jobs.data) {
        let jobs = this.props.jobs.data.get('jobs');
        if (jobs) {
          data = jobs.toArray();

          this.state.inactive = data.filter(i => i.inactive).length > 0
        }
      }
    } else {
      data = this.state.jobStatus;
    }

    return data;
  }

  renderToolbar() {
    if (subsections[this.props.params.section]) {
      return (
        <Toolbar
          section='Jobs'
          subsection={subsections[this.props.params.section]}
          // details={ReleaseInfo({ app: this.context.currentApp })}
          details='Updated in 15 seconds'
        >
          {this.props.availableJobs && this.props.availableJobs.length > 0
            ? <Button color='blue' value='Schedule a job' onClick={this.navigateToNew.bind(this)} />
            : <p>Create a <strong>Parse.Cloud.job</strong> function in your Cloud Code to create a new Scheduled Job</p>
          }
        </Toolbar>
      );
    }
    return null;
  }
}
